import axios from "axios";
import { PRODUCT_CURRENCYS } from "../../types/ProductCurrencyType";

const getAllProductCurrency = (data) => {
	return {
		type: PRODUCT_CURRENCYS,
		payload: data,
	};
};

export const loadAllProductCurrency = ({ page, limit }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`product-currency?page=${page}&count=${limit}`
			);
			//dispatching data
			dispatch(getAllProductCurrency(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
